import { render, staticRenderFns } from "./BlockedIpView.vue?vue&type=template&id=0f70fd0b&scoped=true&"
import script from "./BlockedIpView.vue?vue&type=script&lang=js&"
export * from "./BlockedIpView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f70fd0b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f70fd0b')) {
      api.createRecord('0f70fd0b', component.options)
    } else {
      api.reload('0f70fd0b', component.options)
    }
    module.hot.accept("./BlockedIpView.vue?vue&type=template&id=0f70fd0b&scoped=true&", function () {
      api.rerender('0f70fd0b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/security/BlockedIp/BlockedIpView.vue"
export default component.exports